<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
          <a href="https://www.instagram.com/atlhotwings/" target="new"><i class="icon mdi mdi-instagram mdi-36px"></i></a>
          <a href="https://www.facebook.com/atlhotwingsdotcom/" target="new"><i class="icon mdi mdi-facebook mdi-36px"></i></a>
          <a href="https://twitter.com/atlhotwings" target="new"><i class="icon mdi mdi-twitter mdi-36px"></i></a>
        </p>
        <p>
          <a href="/">© atlhotwings.com</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue